import React from "react";
import "../Manufecturing.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiSettings,
} from "react-icons/fi";



const Manufacturing = () => {


    return (

        <>

            <Header />



            {/* =====================================================
                        MANUFACTURING HERO SECTION
            ===================================================== */}



            <section className="manufacturing-hero">


                <div className="manufacturing-overlay"></div>



                <div className="container">



                    <div className="manufacturing-hero-content">



                        <span className="manufacturing-tag">

                            Manufacturing Technology Solutions

                        </span>





                        <h1>


                            Transforming
                            <span> Manufacturing </span>
                            Through Smart Digital Innovation


                        </h1>






                        <p>


                            Kishancart Digital (OPC) Private Limited
                            empowers manufacturing companies,
                            industrial organizations, factories, and
                            production businesses with innovative
                            digital solutions. We develop smart
                            manufacturing platforms that improve
                            production efficiency, automate operations,
                            optimize resources, enhance quality control,
                            and enable data-driven decisions for
                            modern industries.


                        </p>






                        <div className="manufacturing-hero-btns">


                            {/* Buttons can be added here */}


                            {/*

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >

                                Contact Us

                            </NavLink>


                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >

                                Explore Services

                            </NavLink>


                            */}



                        </div>




                    </div>



                </div>



            </section>







            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}




            <section className="manufacturing-breadcrumb">



                <div className="container">



                    <div className="breadcrumb">





                        <NavLink to="/">


                            <FiHome />


                            Home


                        </NavLink>






                        <FiChevronRight />






                        <span>


                            Solutions


                        </span>






                        <FiChevronRight />







                        <span className="active">



                            <FiSettings />


                            Manufacturing



                        </span>






                    </div>



                </div>



            </section>









            {/* =====================================================
                    MANUFACTURING OVERVIEW
            ===================================================== */}




            <section className="manufacturing-overview">



                <div className="container">





                    <div className="overview-grid">







                        {/* LEFT CONTENT */}





                        <div className="overview-content">






                            <span className="section-tag">


                                Digital Manufacturing Solutions


                            </span>






                            <h2>


                                Smart Technology for
                                <span> Modern Manufacturing</span>


                            </h2>








                            <p>


                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable manufacturing
                                technology solutions that help factories,
                                industries, and production businesses
                                improve operational efficiency, reduce
                                costs, and optimize manufacturing
                                processes.


                            </p>








                            <p>


                                Our digital manufacturing platforms enable
                                smart factory management, production
                                monitoring, inventory control, quality
                                management, automation, and real-time
                                analytics. We help industries adopt
                                Industry 4.0 technologies to build
                                connected and intelligent manufacturing
                                ecosystems.


                            </p>








                            <div className="overview-list">






                                <div className="overview-item">


                                    ✓ Smart Factory Management System


                                </div>







                                <div className="overview-item">


                                    ✓ Production Monitoring & Analytics


                                </div>







                                <div className="overview-item">


                                    ✓ Manufacturing Automation


                                </div>







                                <div className="overview-item">


                                    ✓ Inventory Management Solutions


                                </div>







                                <div className="overview-item">


                                    ✓ Quality Management System


                                </div>







                                <div className="overview-item">


                                    ✓ IoT Based Manufacturing Solutions


                                </div>






                            </div>






                        </div>









                        {/* RIGHT CARDS */}








                        <div className="overview-cards">







                            <div className="overview-card">



                                <h3>


                                    Smart Factory Management


                                </h3>






                                <p>


                                    Monitor factory operations,
                                    production processes, machines,
                                    and resources through a centralized
                                    digital manufacturing platform.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Production Monitoring


                                </h3>






                                <p>


                                    Track production performance,
                                    machine efficiency, workflow status,
                                    and manufacturing operations
                                    in real-time.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Manufacturing Automation


                                </h3>






                                <p>


                                    Automate industrial workflows,
                                    production planning, inventory,
                                    reporting, and operational
                                    management processes.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Industrial Analytics


                                </h3>






                                <p>


                                    Analyze production data, machine
                                    performance, quality metrics, and
                                    business insights through smart
                                    dashboards.


                                </p>





                            </div>








                        </div>






                    </div>





                </div>





            </section>





            {/* PART 2 STARTS HERE */}

            {/* =====================================================
        MANUFACTURING CHALLENGES
===================================================== */}


            <section className="manufacturing-challenges">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Industry Challenges

                        </span>



                        <h2>

                            Challenges in
                            <span> Modern Manufacturing Operations</span>

                        </h2>



                        <p>

                            Manufacturing companies face challenges related
                            to production efficiency, supply chain visibility,
                            quality control, inventory management, and
                            operational automation. Our digital manufacturing
                            solutions help businesses overcome these challenges
                            with advanced technology.

                        </p>



                    </div>





                    <div className="challenge-grid">



                        <div className="challenge-card">


                            <h3>

                                Production Management

                            </h3>


                            <p>

                                Manage production planning, workflows,
                                manufacturing processes, and operational
                                activities through centralized digital platforms.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Supply Chain Visibility

                            </h3>


                            <p>

                                Improve supply chain coordination from
                                procurement and manufacturing to delivery
                                using real-time tracking solutions.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Inventory Management

                            </h3>


                            <p>

                                Optimize raw materials, finished products,
                                warehouse operations, and stock management
                                with automated inventory systems.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Quality Control

                            </h3>


                            <p>

                                Monitor manufacturing quality, inspection
                                processes, and production standards using
                                digital quality management solutions.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Machine Monitoring

                            </h3>


                            <p>

                                Track equipment performance, machine
                                utilization, maintenance schedules, and
                                operational efficiency.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Data Management

                            </h3>


                            <p>

                                Collect and analyze manufacturing data
                                to improve forecasting, decision making,
                                and business performance.

                            </p>


                        </div>




                    </div>



                </div>


            </section>









            {/* =====================================================
        MANUFACTURING SOLUTIONS
===================================================== */}



            <section className="manufacturing-solutions">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Our Manufacturing Solutions

                        </span>





                        <h2>

                            Smart Digital Solutions for
                            <span> Manufacturing Industry</span>

                        </h2>





                        <p>

                            Kishancart Digital develops scalable and
                            technology-driven manufacturing solutions that
                            help industries automate operations, improve
                            productivity, reduce costs, and build efficient
                            manufacturing ecosystems.

                        </p>



                    </div>








                    <div className="solutions-grid">






                        <div className="solution-card">


                            <h3>

                                Manufacturing ERP Solutions

                            </h3>


                            <p>

                                Manage production, inventory, finance,
                                procurement, and business operations through
                                integrated ERP platforms.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Production Management System

                            </h3>


                            <p>

                                Digitally manage production planning,
                                workflows, scheduling, and manufacturing
                                processes efficiently.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Smart Factory Solutions

                            </h3>


                            <p>

                                Enable automation, IoT integration,
                                machine monitoring, and intelligent
                                manufacturing operations.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Inventory Management System

                            </h3>


                            <p>

                                Track raw materials, warehouse inventory,
                                stock movement, and finished goods with
                                real-time visibility.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Supply Chain Management

                            </h3>


                            <p>

                                Improve supplier coordination, logistics,
                                procurement, and distribution processes
                                through digital platforms.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Quality Management System

                            </h3>


                            <p>

                                Monitor quality checks, inspections,
                                compliance processes, and manufacturing
                                standards.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                IoT Manufacturing Solutions

                            </h3>


                            <p>

                                Connect machines and devices to collect
                                real-time production data and improve
                                operational efficiency.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Manufacturing Analytics Dashboard

                            </h3>


                            <p>

                                Analyze production data, performance
                                metrics, machine efficiency, and business
                                insights through dashboards.

                            </p>


                        </div>






                    </div>



                </div>



            </section>

            {/* =====================================================
        MANUFACTURING FEATURES
===================================================== */}


            <section className="manufacturing-features">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Key Features

                        </span>





                        <h2>

                            Powerful Features for
                            <span> Modern Manufacturing Platforms</span>

                        </h2>





                        <p>

                            Our manufacturing technology solutions provide
                            advanced features that help industries automate
                            processes, improve productivity, and manage
                            operations efficiently.

                        </p>



                    </div>








                    <div className="features-grid">






                        <div className="feature-card">

                            <h3>

                                Production Planning

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Manufacturing Workflow Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Machine Monitoring

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                IoT Device Integration

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Inventory Tracking

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Warehouse Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Quality Inspection Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Supplier Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Order Management

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Manufacturing Reports

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Real-Time Analytics

                            </h3>

                        </div>






                        <div className="feature-card">

                            <h3>

                                Secure Cloud Platform

                            </h3>

                        </div>





                    </div>



                </div>



            </section>









            {/* =====================================================
        BUSINESS BENEFITS
===================================================== */}



            <section className="manufacturing-benefits">


                <div className="container">





                    <div className="section-heading">


                        <span className="section-tag">

                            Business Benefits

                        </span>





                        <h2>

                            Why Manufacturing Companies Choose
                            <span> Kishancart Digital</span>

                        </h2>





                        <p>

                            Our digital manufacturing solutions help
                            businesses improve operational efficiency,
                            reduce production costs, optimize resources,
                            and create future-ready manufacturing systems.

                        </p>



                    </div>








                    <div className="benefits-grid">






                        <div className="benefit-card">


                            <h3>

                                Increased Production Efficiency

                            </h3>


                            <p>

                                Improve manufacturing productivity through
                                automation, smart workflows, and optimized
                                production processes.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Reduced Operational Costs

                            </h3>


                            <p>

                                Reduce manual efforts, production delays,
                                and resource wastage through intelligent
                                digital solutions.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Better Inventory Control

                            </h3>


                            <p>

                                Maintain accurate inventory records,
                                optimize stock levels, and improve
                                warehouse management.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Improved Quality Management

                            </h3>


                            <p>

                                Enhance product quality through digital
                                inspection systems, monitoring, and
                                automated quality processes.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Data-Driven Manufacturing

                            </h3>


                            <p>

                                Make better decisions using real-time
                                manufacturing data, analytics, and
                                performance insights.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Scalable Manufacturing Solutions

                            </h3>


                            <p>

                                Easily scale manufacturing operations
                                across multiple plants, locations,
                                and business units.

                            </p>


                        </div>





                    </div>





                </div>



            </section>









            {/* =====================================================
        FOOTER
===================================================== */}


            <Footer />



        </>

    );

};



export default Manufacturing;